import Fetcher from "../../../services/fetcher";
import settings from "../../../settings";

const createBestOf = (titleBestoff: any, allDayBestOf: any, postByDay: any, postCover: any, typeBestOf: any) => {
  return Fetcher.post(settings.bestOfApi + "/create", JSON.stringify({
    title: titleBestoff,
    days: allDayBestOf,
    bestOfPosts: postByDay,
    postCover,
    typeBestOf: typeBestOf,
    publish: false,
    created: new Date().getTime(),
  }));
};

export default createBestOf;
